import styled from 'styled-components';

export const Amount = styled.div`
  font-size: 13px;
  font-weight: 700;
  margin-left: 6px;
`;

export const Container = styled.div`
  align-items: center;
  display: flex;
`;

export const CurrencyLogo = styled.img`
  border-radius: 50%;
  height: 13px;
  width: 13px;
`;
